import React, { useEffect } from 'react';
import { Table, Button, Modal, Alert, message } from 'antd';
import './appManagement.less';
import { getAppManagementList, deleteAppManagement } from '../../../api'
import { useRequest, useUpdateEffect } from 'ahooks'
import { useRecoilValue } from 'recoil'
import { userInfo as recoilUserInfo, appReady } from '../../../recoil'
import moment from 'moment';
import { i18n as i } from "../../../i18n"


function AppManagement() {
  const [data, setData] = React.useState<Array<AppManagementType.AppManagement>>([])
  const userInfo = useRecoilValue(recoilUserInfo);
  const appIsReady = useRecoilValue(appReady);

  useEffect(() => {
    if (userInfo && userInfo.person)
      runGetAppManagementList()
  }, []);

  useUpdateEffect(() => {
    if (appIsReady)
      runGetAppManagementList()
  }, [appIsReady]);

  const { run: runGetAppManagementList, loading } = useRequest(getAppManagementList, {
    manual: true,
    onSuccess: (res) => {
      if (res) {
        setData(res.clients)
      }
    }
  })

  const onDelete = async (clientId: string) => {
    try {
      const res = await deleteAppManagement({clientId})
      if(res.code === 0) {
        message.success(i("删除成功"))
        runGetAppManagementList()
      } else {
        const errorCodes: any = {
          13: i("服务异常，请重试"),
          20000: i("无法删除非自己创建的应用")
        }
        message.error(errorCodes[res.code] || i("出错啦"))
      }
    } catch (error) {
      message.error(i("删除失败"))
    }
  }

  const confirmDelete = (openAccessKeyId: string) => {
    Modal.confirm({
      title: i("提示"),
      content: i("您是否确认删除，会影响已有的开发对接成果？"),
      onOk: () => onDelete(openAccessKeyId),
      okText: i("确定"),
      cancelText: i("取消"),
      onCancel: () => Modal.destroyAll()
    })
  }

  const columns: any = [
    {
      title: i('名称'),
      dataIndex: 'displayName',
    },
    {
      title: i('描述'),
      dataIndex: 'description',
    },
    {
      title: i('应用ID'),
      dataIndex: 'id',
      width: '350px',
    },
    {
      title: i('创建时间'),
      dataIndex: 'createTime',
      width: '200px',
      render: (text: string)=>{
        return (
          <>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</>
        )
      }
    },
    {
      title: i("操作"),
      key: "operation",
      width: "200px",
      fixed: 'right',
      render: (row: any) => {
        return (
          <>
            <Button type='link' onClick={() => confirmDelete(row.id)}>{i("删除")}</Button>
          </>  
        )
      }
    }
  ];

  return (
    <div className='main'>
      <Alert
        style={{ marginBottom: 16 }}
        type="info"
        showIcon
        message={i("应用管理功能已停止使用，本页面仅保留现有应用数据展示。新创建的AccessKey将同时生成应用信息，包括ClientID和ClientSecret。")}
      />
      <Table rowKey='id' columns={columns} loading={loading} dataSource={data} pagination={false} scroll={{ y: 999999 }} />
    </div>
  );
}

export default AppManagement
